let isEnable = true;

function throttle(method, delay = 1000) {
  if (isEnable) {
    method.call();
  }
  isEnable = false;
  clearTimeout(method.tId);
  method.tId = setTimeout(function () {
    isEnable = true;
  }, delay);
}

function addEvent(element, event, listener) {
  if (element.addEventListener) {
    element.addEventListener(event, listener, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + event, listener);
  } else {
    element['on' + event] = listener;
  }
}

const DIRECTIVE = [
  {
    name: 'reClick',
    direct: {
      bind: function (el, binding) {
        addEvent(el, 'click', function (e) {
          e.stopPropagation();
          throttle(binding.value);
        });
      },
      unbind: function (el) {
        addEvent(el, 'click', function () {});
      }
    }
  }
];

export default DIRECTIVE;
